import './SummaryStepModal.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_InfoModal } from '../../../../../../../../design/modals/infoModal/S_InfoModal';
import { ImportSummaryPaneContainer } from './importSummaryPane/ImportSummaryPane.container';
import { UnregisteredUsersSummaryPaneContainer } from './unregisteredUsersSummaryPane/UnregisteredUsersSummaryPane.container';

interface IProps {
  show: boolean;
  onHide: () => void;
}

export const SummaryStepModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { show, onHide } = props;
  return (
    <S_InfoModal
      headerText={t('new.projects.details.import_annotations.steps.summary.header')}
      buttonText={t('new.projects.details.import_annotations.steps.summary.close')}
      onClick={onHide}
      toggle={onHide}
      isOpen={show}
    >
      <div className='summary-step-body'>
        <div>{t('new.projects.details.import_annotations.steps.summary.summary')}: </div>
        <ImportSummaryPaneContainer />
        <UnregisteredUsersSummaryPaneContainer />
      </div>
    </S_InfoModal>
  );
});
